import React from 'react';

import { Header, Icon, Grid } from 'semantic-ui-react';

import { useCustomerBillingAccount } from '../../_services';
import { CardDetailsModal } from './CardDetailsModal';

export const CardDetails = ({ customerId, edit }) => {
  const account = useCustomerBillingAccount(customerId);

  return (
    <React.Fragment>
      <Header as="h3">
        <Icon name="calculator" />
        Card Details
      </Header>
      <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <Header
              style={{
                color: account?.card_name ? 'black' : 'rgb(255, 100, 100)'
              }}
              as="h4"
            >
              *Card Name
            </Header>
            <Header as="h5" color="grey" style={{ marginTop: 0 }}>
              {account && account.card_name}
            </Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={8}>
            <Header
              style={{
                color: account?.card_last4_digits
                  ? 'black'
                  : 'rgb(255, 100, 100)'
              }}
              as="h4"
            >
              *Card Number
            </Header>
            <Header as="h5" color="grey" style={{ marginTop: 0 }}>
              {account &&
                account.card_last4_digits &&
                '**** **** **** ' + account.card_last4_digits}
            </Header>
          </Grid.Column>
          <Grid.Column width={8}>
            <Header
              style={{
                color: account?.card_expiry ? 'black' : 'rgb(255, 100, 100)'
              }}
              as="h4"
            >
              *Expiry Date
            </Header>
            <Header as="h5" color="grey" style={{ marginTop: 0 }}>
              {account && account.card_expiry}
            </Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <CardDetailsModal buttonText="Edit Payment Card" edit={edit} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </React.Fragment>
  );
};
